import React from 'react'
import qaCallout from './qa-callout'

const doc = {
  title: 'Q&A: No "Model" type patterns found - Custom .pat problems',
  slug: 'qa-no-model-type-patterns-found',
  tags: ['forum', 'q&a', 'question', 'answer'],
  category: 'q-and-a',
  content: (props) => {
    return <div>
      {qaCallout}
      <p>
        <a href="https://forums.autodesk.com/t5/revit-architecture-forum/no-quot-model-quot-type-patterns-found-custom-pat-problems/m-p/9561439#M285673" target="_blank" rel="noreferrer">Read more of this thread on forums.autodesk.com</a>
      </p>
      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title">Asked by <a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/7753939" target="_blank" rel="noreferrer">@jackson.hollisGLMV</a> on 6/4/2020 on the Revit Architecture Forum:</strong><br/>
        Hello all,
        <br/><br/>
        Unfortunately, I cannot seem to figure out how to get my own custom pattern to work. I've never had to make a custom .pat file before but the time has finally come during one of my projects.
        <br/><br/>
        Ultimately, I would like a pattern that is alternating brick stacked soldier course and row-lock. I've attached a picture with the code that I need help with and the drawing of the pattern I would like.
        <br/><br/>
        Here is the code I have so far:
        <br/><br/>
        ;%UNITS=INCH<br/>
        *Brick_(Soldier/Row_Lock)<br/>
        ;%TYPE=MODEL<br/>
        0, 0, 0, 0, 11.25, 4.5, 4.5<br/>
        0, 2.25, 3.625, 0, 11.25, 2.25, -2.25<br/>
        0, 0, 7.625, 0, 11.25, 2.25, -2.25<br/>
        90, 0, 0, 4.5, 0, 11.25, 11.25<br/>
        90, 2.25, 0, 4.5, 0, 11.25, 11.25<br/>
        <br/><br/>
        Whenever you find the time to help me out, I would gladly appreciate you.
        <br/><br/>
        Thank you<br/>
        <img src="/img/forum_content/pat_pencil.jpg" style={{maxWidth: '100%'}}/>
      </blockquote>
      
      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        Hey @jackson.hollisGLMV 
        <br/><br/>
        The problem with yours as listed would be the 0 offsets in line 4 & 5... (11 & 12 in image). When i load it into Pattycake it spits out those as non-compliant right away.
        <br/>
        <img src="/img/forum_content/Pattycake_Kyle_0-1591310255435.png" style={{maxWidth: '100%'}}/>
        <br/><br/>
        This what you are looking for? Made with our Draw-in-Web then baked: <a href="https://pattycake.io/pat/000ey7rpn6w" target="_blank">https://pattycake.io/pat/000ey7rpn6w</a>
        <br/>
        <img src="/img/forum_content/ExampleImage.jpg" style={{maxWidth: '100%'}}/>
        <br/><br/>
        Let me know if i can help some more! Cheers! 🎂
      </blockquote> 

      <blockquote className="doc-blockquote doc-blockquote-user">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/7753939" target="_blank" rel="noreferrer">@jackson.hollisGLMV</a> on 6/4/2020 on the Revit Architecture Forum:</strong><br/>
        @Pattycake_Kyle Thank you sir! I will be using your product to aid me in the future and refer it within my company whenever someone needs to make a .pat file! Much appreciated 🙂
      </blockquote>

      <blockquote className="doc-blockquote">
        <strong className="doc-blockquote-title"><a href="https://forums.autodesk.com/t5/user/viewprofilepage/user-id/6702606" target="_blank" rel="noreferrer">@Pattycake_Kyle</a> on 7/19/2020:</strong><br/>
        @jackson.hollisGLMV Awesome and so happy to hear! 😄
        <br/><br/>
        I laughed when I saw your color coded diagram of lines... Literally that is exactly how we set up Pattycake... and the exact same thing i used to do by hand as well! (great minds think alike)
        <br/><br/>
        Super glad to have you and reach out hi@pattycake.io anytime for help or suggestions for improvement. We'll be pushing a nice update soon, so keep an eye out for that 🎂😎
      </blockquote> 

    </div>
  }
}

export default doc;


// WEBPACK FOOTER //
// ./src/docs/qa-no-model-type-patterns-found.js